import { curry } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import sequenceComponentState from 'lib/sequence/component/state'
import { hide, show } from 'lib/sequence/component/state/hidden'

const {
  get: getActiveTab,
  set: setActiveTab,
} = sequenceComponentState('activeTab')

/**
 * If the current `activeTab` of the `tabs` element is not the first one, sets the previous tab
 * as the element's `activeTab`.
 *
 * If the current `activeTab` is the first one, redirects back.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const nextTab = async (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { tabs } = find(actionComponent)
  const [btnNext, btnUnderstood] = actionComponent[G.ACTIONS]
  const activeTab = getActiveTab(tabs)
  const children: [] = tabs[G.CHILDREN]
  const childrenIds = children.map((child: any) => child[G.PROPS].id)
  const index = childrenIds.indexOf(activeTab)

  if (index + 1 < childrenIds.length) {
    setActiveTab(tabs, childrenIds[index + 1])
  }

  if (index + 1 === childrenIds.length - 1) {
    hide(btnNext)
    show(btnUnderstood)
  }

  await module[G.ADAPTER][G.UI].update(module)
}

export default curry(nextTab)
